import { internal, template } from '../../vendor/elix.js';
import FilledFloatingLabelInputLightMixin from '../mixins/filled-floating-label-input-light-mixin.js';
import TpSelectFilledMixin from './tp-select-filled-mixin.js';
import TpSelectBase from './tp-select-base.js';

class TpSelectFilledLight extends 
  TpSelectFilledMixin(
  FilledFloatingLabelInputLightMixin(
    TpSelectBase
  )) {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`
          <style>

            .inputStateContainer:not(.disabled) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled) ${innerSelector}:active {
              background-color: var(--tp-filled-select-mixin-light-background-color-focused);
            }

          </style>
        `
      );

    }

  }

export default TpSelectFilledLight;
